import { ofType, unionize, UnionOf } from 'src/framework'
import { TestContent } from 'src/services/ds.service'

export interface SelectTest {
  type: 'UpdateTestSelectTest'
  testName: string
}

export interface LoadTestSuccess {
  type: 'UpdateTestLoadTestSuccess'
  test: TestContent
}

export interface LoadTestFailure {
  type: 'UpdateTestLoadTestFailure'
  testName: string
}

export interface SaveTest {
  type: 'UpdateTestSaveTest'
  test: TestContent
}

export interface SaveTestSuccess {
  type: 'UpdateTestSaveTestSuccess'
  test: TestContent
}

export interface SaveTestFailure {
  type: 'UpdateTestSaveTestFailure'
  test: TestContent
}

export const updateTestActions = unionize({
  ...ofType<SelectTest>('UpdateTestSelectTest'),
  ...ofType<LoadTestSuccess>('UpdateTestLoadTestSuccess'),
  ...ofType<LoadTestFailure>('UpdateTestLoadTestFailure'),
  ...ofType<SaveTest>('UpdateTestSaveTest'),
  ...ofType<SaveTestSuccess>('UpdateTestSaveTestSuccess'),
  ...ofType<SaveTestFailure>('UpdateTestSaveTestFailure')
})

export type UpdateTestActions = UnionOf<typeof updateTestActions>



// WEBPACK FOOTER //
// ./src/tests-components/update-test/update-test.actions.ts